module.exports = "<div class=\"dialog dialog-add-to-cart\"> <div class=\"box box-2\"> <div class=\"box-hd is-info\"> <h3>{{ ::title }}</h3> </div> <div class=box-bd> {{ ::msg }} </div> <div class=box-ft> <ul class=\"btn-holder btn-holder-2-btn\"> <li><a ng-click=closeThisDialog(0) role=button class=\"btn btn-primary-outline btn-block\" translate>No</a></li> <li><a ng-click=closeThisDialog(1) role=button class=\"btn btn-primary btn-block\" translate>Yes</a></li> </ul> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./common/templates/confirm.html
// module id = 506
// module chunks = 0